import { useEffect, useState } from "react";
import { useRenterDashboardContext } from "../../renter-dashboard/useRenterDashboardContext";
import { IVehicle, emptyVehicle } from "../../../../../types/vehicle.type";
import { getVehicleById } from "../../../../../common/services/vehicles.api";
import { NavLink } from "react-router-dom";
import {
  formatDateNoHours,
  getDaysUntilExpiration,
} from "../../../../../common/helpers/date.helpers";
import VehicleBlockToggle from "./VehicleBlockToggle";

const VehcileBound: React.FC = () => {
  const { renter } = useRenterDashboardContext();
  const [vehicle, setVehicle] = useState<IVehicle>(emptyVehicle());
  const [vehicleBlock, setVehicleBlock] = useState(
    vehicle.velotrackSettings.blocked ?? false
  );

  useEffect(() => {
    setVehicleBlock(vehicle.velotrackSettings.blocked ?? false);
  }, [vehicle.velotrackSettings.blocked, vehicleBlock]);

  useEffect(() => {
    const loadVehicle = async (vehcileId) => {
      const result = await getVehicleById(vehcileId);
      if (result.ok) {
        setVehicle(result.data as IVehicle);
        setVehicleBlock(result.data.velotrackSettings.blocked || false);
      }
    };
    if (renter?.activationData?.vehicle?.id) {
      loadVehicle(renter?.activationData?.vehicle?.id);
    }
  }, [renter]);

  const daysUntilExpiration = renter?.activationData?.currentContractStartDate
    ? getDaysUntilExpiration(renter?.activationData?.plan?.subscriptionEndDate)
    : "Data não disponível";

  const handleStatusChange = () => {
    setVehicleBlock(vehicle.velotrackSettings.blocked ?? false);
  };

  const initalDateLocation = formatDateNoHours(
    renter.activationData.activationDate
  );
  const statusAlterationDate =
    renter.additionsService[renter.additionsService.length - 1]?.serviceAction;
  const dateInformation = formatDateNoHours(
    renter.additionsService[renter.additionsService.length - 1]?.createdAt
  );

  return (
    <div>
      <div className="grid grid-cols-2 dark:text-black">
        <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0 dark:text-black">
          {" "}
          Plano Vigente:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
          {" "}
          {renter?.activationData?.plan?.label || "-"}{" "}
        </span>
        <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0">
          {" "}
          Data da locação:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
          {" "}
          {initalDateLocation || "-"}
        </span>
        {dateInformation && statusAlterationDate && (
          <>
            <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0">
              {" "}
              Data em que {statusAlterationDate} o PLUS:{" "}
            </span>
            <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
              {" "}
              {dateInformation}
            </span>
          </>
        )}

        <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0">
          {" "}
          O plano vence em:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
          {" "}
          {daysUntilExpiration || "Data não disponível"}
        </span>
        <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0">
          {" "}
          Placa da Moto:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
          <NavLink
            to={`/veiculos/${vehicle?.licensePlate}`}
            className=" text-indigo-600 hover:text-indigo-800"
          >
            {vehicle?.licensePlate || "-"}
          </NavLink>
        </span>
        <span className="p-2 flex items-center bg-white/50 rounded-bl-md border border-gray/50 border-r-0">
          {" "}
          Hodômetro:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/50 rounded-br-md border border-gray/50 border-l-0">
          {" "}
          {vehicle?.odometerLocavibe || "-"}{" "}
        </span>
        <span className="p-2 flex items-center bg-white/30 rounded-tl-md border border-gray/50 border-r-0">
          {" "}
          Proprietário:{" "}
        </span>
        <span className="p-2 flex items-center justify-end bg-white/30 rounded-tr-md border border-gray/50 border-l-0">
          {" "}
          {vehicle?.partnerInfo.companyName || "-"}{" "}
        </span>
      </div>
      <VehicleBlockToggle
        vehicleId={renter?.activationData?.vehicle?.id}
        initialVehicleBlockStatus={vehicleBlock}
        onStatusChange={handleStatusChange}
      />
    </div>
  );
};

export default VehcileBound;
